import React from "react";

const corporateData = [
  {
    title: "Office & Hospitality Décor",
    description: "Hotels, Guest Houses, Corporate Offices",
  },
  {
    title: "Corporate Gifting Programs",
    description: "Diwali, Annual Events",
  },
  {
    title: "Partnership with Architects & Designers",
    description: "",
  },
];

const CorporateCard = ({ title, description }) => {
  return (
    <div className="card h-100 border-0 rounded-4 shadow-sm corporate-card">
      <div className="card-body text-center p-4">
        <h5 className="card-title fw-bold mb-3">{title}</h5>
        {description && <p className="card-text text-muted">{description}</p>}
      </div>
    </div>
  );
};

const CorporateSolutionsSection = () => {
  return (
    <section className="py-5">
      <div className="container">
        <h2 className="text-center mb-5 fw-bold fs-1">Corporate Solutions</h2>
        <div className="row g-4 mb-5">
          {corporateData.map((item, index) => (
            <div key={index} className="col-12 col-md-4">
              <CorporateCard title={item.title} description={item.description} />
            </div>
          ))}
        </div>
        <div className="text-center">
          <button className="btn btn-gradient btn-lg fw-bold text-white px-5 py-3">
            Book a Corporate Consultation
          </button>
        </div>
      </div>

      <style jsx>{`
        .corporate-card {
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          cursor: pointer;
          background: white;
        }
        .corporate-card:hover {
          transform: translateY(-10px);
          box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15);
        }
        .btn-gradient {
          background: #02132f;
          border: none;
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        .btn-gradient:hover {
          transform: translateY(-3px);
          box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
        }
      `}</style>
    </section>
  );
};

export default CorporateSolutionsSection;
